import { render, staticRenderFns } from "./bind-card.vue?vue&type=template&id=753f7a1c&scoped=true&"
import script from "./bind-card.vue?vue&type=script&lang=js&"
export * from "./bind-card.vue?vue&type=script&lang=js&"
import style0 from "./bind-card.vue?vue&type=style&index=0&id=753f7a1c&prod&lang=css&"
import style1 from "./bind-card.vue?vue&type=style&index=1&id=753f7a1c&prod&lang=less&"
import style2 from "./bind-card.vue?vue&type=style&index=2&id=753f7a1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753f7a1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
